import {
  isIOS,
  isMobile,
  isSafari,
  isMacOS,
  isIOSWebView,
  isAndroidWebView,
} from "@scrile/tools/dist/lib/browserUtils";
export const IS_BROWSER = process.env.VUE_APP_SERVER === "false";
export { isIOS, isMobile, isSafari, isMacOS, isIOSWebView, isAndroidWebView };

export const isNotificationsSupported = () =>
  "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
export const getNotificationsPermissions = () => {
  if (!isNotificationsSupported()) {
    return "default";
  }
  return Notification.permission;
};
